import React from "react";

const MaintenancePage = () => {
  return (
    <div
      style={{
        backgroundColor: "#e6dcf8",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          padding: "60px 80px",
          textAlign: "center",
          maxWidth: "600px",
        }}
      >
        {/* Illustration */}
        <div style={{ marginBottom: "30px" }}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
            alt="Under Maintenance"
            style={{ width: "160px", height: "160px", objectFit: "contain" }}
          />
        </div>

        {/* Headline */}
        <h1
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#2d2d2d",
            marginBottom: "10px",
          }}
        >
          Sorry! We Are Under Maintenance
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: "15px",
            color: "#555",
            lineHeight: "1.6",
            marginBottom: "12px",
          }}
        >
          Sorry for the inconvenience, but we’re performing some maintenance at
          the moment.
        </p>

        <p
          style={{
            fontSize: "15px",
            color: "#555",
            lineHeight: "1.6",
          }}
        >
          If you need to reach us, you can always contact us on{" "}
          <a
            href="mailto:technicalwork883@gmail.com"
            style={{ color: "#7b4fff", fontWeight: "500", textDecoration: "none" }}
          >
            technicalwork883@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
